import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';

const BASE_URL = `${import.meta.env.VITE_BACKEND_URL}/api/users`;

type CheckTestRateLimitResponse = {
  usedTokens: number;
};

export const apiUsers = createApi({
  reducerPath: 'apiUsers',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl: BASE_URL }),
  tagTypes: ['UserTestRateLimit'],
  endpoints: (build) => ({
    activateAccount: build.mutation({
      query: (data) => ({
        url: `/activateAccount/${data.token}`,
        method: 'POST',
        body: { password: data.password }
      })
    }),
    checkTestRateLimit: build.query<CheckTestRateLimitResponse, void>({
      providesTags: ['UserTestRateLimit'],
      query: () => ({
        url: `/checkTestRateLimit`
      })
    }),
    validateConfirmationToken: build.query<{ message: string }, string>({
      query: (token) => `/confirmAccount/${token}`
    }),
    confirmAccount: build.mutation<{ message: string }, string>({
      query: (token) => ({
        url: `/confirmAccount/${token}`,
        method: 'POST'
      })
    })
  })
});

export const {
  useActivateAccountMutation,
  useCheckTestRateLimitQuery,
  useLazyValidateConfirmationTokenQuery,
  useConfirmAccountMutation
} = apiUsers;
